import {useState} from "react";
import Switch from "react-switch";

export function Alert() {
    const [notificationList, setNotificationList] = useState({
        message: {
            checked: true,
            text: "문자"
        },
        kakao: {
            checked: false,
            text: "카카오톡"
        },
        email: {
            checked: false,
            text: "이메일" // 원래 "문자"였는데 "이메일"로 수정
        }
    });
    const [notificationTypeList, setNotificationTypeList] = useState([
        {
            typeText: "시험 관련 일정 알림",
            val: true,
        },
        {
            typeText: "결제 관련 알림",
            val: true,
        },
        {
            typeText: "문의 관련 알림",
            val: false,
        }
    ]);
    
    const [emailConsent, setEmailConsent] = useState(true);
    
    
    const toggleNotificationType = (idx) => {
        const list = [...notificationTypeList]
        list[idx]["val"] = !list[idx]["val"]
        setNotificationTypeList(list)
    };
    
    // 체크박스 변경 처리
    const handleCheckboxChange = (key) => {
        setNotificationList((prev) => ({
            ...prev,
            [key]: {
                ...prev[key],
                checked: !prev[key].checked
            }
        }));
    };
    return (
        <section className={`flex-col p-5 w-[100%] gap-14`}>
            <div className={`flex justify-between items-center`}>
                <h1 className={`font-bold text-2xl`}>알림 설정</h1>
                <button className={`bg-black text-white py-2 px-5 rounded`}>
                    저장
                </button>
            </div>
            
            <ul className={`py-5 px-2 flex items-center gap-4 border-2 rounded-lg mt-4 border-gray-200`}>
                {Object.entries(notificationList).map(([key, value]) => (
                    <li key={key} className="flex items-center ">
                        
                        <input
                            type="checkbox"
                            id={key}
                            checked={value.checked}
                            onChange={() => handleCheckboxChange(key)}
                            className="w-5 h-5 "
                        />
                        <img src={`/images/alert/${key}.svg`} alt="" className={`ml-3 mr-1`}/>
                        <label htmlFor={key} className="text-lg">
                            
                            {value.text}
                        </label>
                    </li>
                ))}
            </ul>
            <div className={``}>
                {
                    notificationTypeList.map((item, idx) => {
                            return <div key={idx} className={`flex justify-between items-center py-4 border-b-2`}>
                                <div className={`text-gray-600 text-xl`}>{item.typeText}</div>
                                <Switch onChange={(e) => {
                                    toggleNotificationType(idx)
                                }} checked={item.val}
                                        checkedIcon={false}
                                        uncheckedIcon={false}
                                        onColor={"#00000"}
                                />
                            </div>
                        }
                    )
                }
            </div>
            
            <div>
                <div className={`flex justify-between items-center mb-2`}>
                    <div className={`flex items-center gap-1`}>
                        <input type="checkbox" checked={emailConsent} onClick={() => {
                            setEmailConsent(!emailConsent)
                        }} className={`w-5 h-5`}/> 마케팅 메일 수신 동의
                    </div>
                    <div>
                        전문보기
                    </div>
                </div>
                <p>마케팅 메일에 수신 동의 해 주시면 다양한 혜택을 받으실 수 있습니다</p>
            </div>
        
        </section>
    );
}
